import React from 'react';
import { cn } from '@/lib/utils';

const cardVariants = {
  flat: 'bg-white rounded-2xl border border-brand-border shadow-sm',
  elevated: 'bg-white rounded-2xl border border-brand-border shadow-md',
  danger: 'bg-brand-error/5 rounded-2xl border border-brand-error/20 shadow-sm',
};

const cardPaddings = {
  none: 'p-0',
  sm: 'p-2 md:p-3',
  md: 'p-3 md:p-4 lg:p-5',
  lg: 'p-4 md:p-5 lg:p-6',
};

interface CardProps {
  children: React.ReactNode;
  variant?: keyof typeof cardVariants;
  padding?: keyof typeof cardPaddings;
  className?: string;
  as?: React.ElementType;
}

export default function Card({
  children,
  variant = 'flat',
  padding = 'lg',
  className,
  as: Tag = 'div',
}: CardProps) {
  return (
    <Tag className={cn(cardVariants[variant], className)}>
      <div className={cardPaddings[padding]}>{children}</div>
    </Tag>
  );
}
